import { render } from "./RowsCounter.vue?vue&type=template&id=526e2c3a"
import script from "./RowsCounter.vue?vue&type=script&lang=js"
export * from "./RowsCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__